type programInformation = {
    programName: string,
    inputParameterClass?: string,
    inputParameterNames?: string[]
}

type programInformations = {
    [name: string]: programInformation
}

const programs: programInformations = {

    RCPHN002: {
        programName: 'com.optum.file.phnpharmacynetwork.program.rcphn002dispnetwork.IRcphn002DispNetworkService',
        inputParameterNames: ["restrictDefaultCarrier", "phnPharmacyNetworkId"],
        inputParameterClass: 'com.optum.file.phnpharmacynetwork.program.rcphn002dispnetwork.Rcphn002DispNetworkParams'
    },
    RCSNH002 : {
        programName: 'com.optum.file.snhsupernetworkheader.program.rcsnh002dispnetwork.IRcsnh002DispNetworkService',
        inputParameterNames: ["snhSuperNetworkId"],
        inputParameterClass: 'com.optum.file.snhsupernetworkheader.program.rcsnh002dispnetwork.Rcsnh002DispNetworkParams'
    },
    RCSNH990 : {
        programName: 'com.optum.file.snhsupernetworkheader.program.rcsnh990selectanetwork.IRcsnh990SelectANetworkService',
        inputParameterNames: ["snhSuperNetworkId"],
        inputParameterClass: 'com.optum.file.snhsupernetworkheader.program.rcsnh990selectanetwork.Rcsnh990SelectANetworkParams'
    },
    RCPHN996: {
        programName: 'com.optum.file.phnpharmacynetwork.program.rcphn996seladdpharmacy.IRcphn996SelAddPharmacyService',
        inputParameterNames: ["phnPharmacyNetworkId", "carCarrierId", "regRegionCode", "phnNetworkType"],
        inputParameterClass: 'com.optum.file.phnpharmacynetwork.program.rcphn996seladdpharmacy.Rcphn996SelAddPharmacyParams'
    },
    RCMLS005: {
        programName: 'com.optum.file.mlsmaclistschedule.program.rcmls005selmls.IRcmls005SelMlsService',
        inputParameterNames: ["mlsSchedule"],
        inputParameterClass: 'com.optum.file.mlsmaclistschedule.program.rcmls005selmls.Rcmls005SelMlsParams'
    },
    RCMLS003I: {
        programName: 'com.optum.file.mlsmaclistschedule.program.rcmls003idspmlsrcd.IRcmls003iDspMlsRcdService',
        inputParameterNames: ["mlsSchedule"],
        inputParameterClass: 'com.optum.file.mlsmaclistschedule.program.rcmls003idspmlsrcd.Rcmls003iDspMlsRcdParams'
    },
    RCPRC001: {
        programName: 'com.optum.file.prcpriceschedule.program.rcprc001slctpricesched.IRcprc001SlctPriceSchedService',
        inputParameterNames: ["prcPriceScheduleName"],
        inputParameterClass: 'com.optum.file.prcpriceschedule.program.rcprc001slctpricesched.Rcprc001SlctPriceSchedParams'
    },
    RCPS7004: {
        programName: 'com.optum.file.ps7pricebasisschedule.program.rcps7004selprcbassch.IRcps7004SelPrcBasSchService',
        inputParameterNames: ["ps7PriceBasisSched"],
        inputParameterClass: 'com.optum.file.ps7pricebasisschedule.program.rcps7004selprcbassch.Rcps7004SelPrcBasSchParams'
    },
    RCDPV003: {
        programName: 'com.optum.file.dpvdurppsservices.program.rcdpv003seldurppsserv.IRcdpv003SelDurPpsServService',
        inputParameterNames: ["dpvServicesTable"],
        inputParameterClass: 'com.optum.file.dpvdurppsservices.program.rcdpv003seldurppsserv.Rcdpv003SelDurPpsServParams'
    },
    RCRX10051:{
        programName: 'com.optum.file.rx1pharntwkndclist.program.rcrx10051selndclist.IRcrx10051SelNdcListService',
        inputParameterNames: [],
        inputParameterClass: 'com.freschesolutions.synon2java.service.data.EmptyParam'
    },
    RCRX20051:{
        programName: 'com.optum.file.rx2pharntwkgpilist.program.rcrx20051selgpilist.IRcrx20051SelGpiListService',
        inputParameterNames: [],
        inputParameterClass: 'com.freschesolutions.synon2java.service.data.EmptyParam'
    },
    RCGSI003I: {
        programName: 'com.optum.file.gsigroupscheduleid.program.rcgsi003idspgrpschedid.IRcgsi003iDspGrpschedIdService',
        inputParameterNames: ["gsiGroupScheduleId","workInitialProgramMode"],
        inputParameterClass: 'com.optum.file.gsigroupscheduleid.program.rcgsi003idspgrpschedid.Rcgsi003iDspGrpschedIdParams'
    },
    RCNND001: {
        programName: 'com.optum.file.nndphnndcsuperlistdtl.program.rcnnd001mntphnsndclst.IRcnnd001MntPhnSndcLstService',
        inputParameterNames: ["nnlPhnNdcSuperListid","nndStatus"],
        inputParameterClass: 'com.optum.file.nndphnndcsuperlistdtl.program.rcnnd001mntphnsndclst.Rcnnd001MntPhnSndcLstParams'
    },
    RCGND001: {
        programName: 'com.optum.file.gndphngpisuperlistdtl.program.rcgnd001mntphnsgpilst.IRcgnd001MntPhnSgpiLstService',
        inputParameterNames: ["gnlPhnGpiSuperListid","gndStatus"],
        inputParameterClass: 'com.optum.file.gndphngpisuperlistdtl.program.rcgnd001mntphnsgpilst.Rcgnd001MntPhnSgpiLstParams'
    },
     RCNNL003I: {
        programName: 'com.optum.file.nnlphnndcsuperlist.program.rcnnl003idspphnndcslist.IRcnnl003iDspPhnndcslistService',
        inputParameterNames: ["nnlPhnNdcSuperListid"],
        inputParameterClass: 'com.optum.file.nnlphnndcsuperlist.program.rcnnl003idspphnndcslist.Rcnnl003iDspPhnndcslistParams'
    },
    RCRX4009: {
        programName: 'com.optum.file.rx4pharntwkgpidetail.program.rcrx4009edtmntlistgpi.IRcrx4009EdtMntListGpiService',
        inputParameterNames: ["pgmMode","rx2PharGpiListDescrip","rx2PharGpiListName","rx4PharGpi","rx4PharGpiName","rx8SeqNbr","rx8MultiSourceCode","rx8Status"],
        inputParameterClass: 'com.optum.file.rx4pharntwkgpidetail.program.rcrx4009edtmntlistgpi.Rcrx4009EdtMntListGpiParams'
    },
    RCRX3009: {
        programName: 'com.optum.file.rx3pharntwkndcdetail.program.rcrx3009edtmntndclist.IRcrx3009EdtMntNdcListService',
        inputParameterNames: ["pgmMode","rx1PharNdcListDescrip","rx1PharNdcListName","rx3PharNdcLabelerCde","rx3PharNdcPackageCde","rx3PharNdcProductCde","rx7SeqNbr","rx7Status"],
        inputParameterClass: 'com.optum.file.rx3pharntwkndcdetail.program.rcrx3009edtmntndclist.Rcrx3009EdtMntNdcListParams'
    },
    RCPOH004: {
        programName: 'com.optum.file.pohplanoverrideschdhdr.program.rcpoh004selplanovrdschd.IRcpoh004SelPlanovrdschdService',
        inputParameterNames: ["pohPlanOverrideSchedul"],
        inputParameterClass: 'com.optum.file.pohplanoverrideschdhdr.program.rcpoh004selplanovrdschd.Rcpoh004SelPlanovrdschdParams'
    },
    RCPOH003I:  {
        programName: 'com.optum.file.pohplanoverrideschdhdr.program.rcpoh003idspplanovrdschd.IRcpoh003iDspplanovrdschdService',
        inputParameterNames: ["pohPlanOverrideSchedul"],
        inputParameterClass: 'com.optum.file.pohplanoverrideschdhdr.program.rcpoh003idspplanovrdschd.Rcpoh003iDspplanovrdschdParams'
    },
    RCMSG008: {
        programName: 'com.optum.file.msgmessage.program.rcmsg008dispmsgactive.IRcmsg008DispMsgActiveService',
        inputParameterNames: ["msgMessageCde"],
        inputParameterClass: 'com.optum.file.msgmessage.program.rcmsg008dispmsgactive.Rcmsg008DispMsgActiveParams'
    },
    RCRX3002: {
        programName: 'com.optum.file.rx3pharntwkndcdetail.program.rcrx3002dspndclistbynm.IRcrx3002DspNdcListbynmService',
        inputParameterNames: ["rx1PharNdcListDescrip", "rx1PharNdcListName"],
        inputParameterClass: 'com.optum.file.rx3pharntwkndcdetail.program.rcrx3002dspndclistbynm.Rcrx3002DspNdcListbynmParams'
    },
    RCRX4002: {
        programName: 'com.optum.file.rx4pharntwkgpidetail.program.rcrx4002dspgpilistnam.IRcrx4002DspGpiListNamService',
        inputParameterNames: ["rx2PharGpiListDescrip", "rx2PharGpiListName"],
        inputParameterClass: 'com.optum.file.rx4pharntwkgpidetail.program.rcrx4002dspgpilistnam.Rcrx4002DspGpiListNamParams'
    },
    RCPRX012: {
        programName: 'com.optum.file.prxplanrxnetwork.program.rcprx012dspallplans.IRcprx012DspAllPlansService',
        inputParameterNames: ["carCarrierId", "phnNetworkType", "phnPharmacyNetworkId", "phnPharmacyNetworkName", "phnSeqNbr",
            "planCode", "plnNetworkType", "regRegionCode", "mediatorId"],
        inputParameterClass: 'com.optum.file.prxplanrxnetwork.program.rcprx012dspallplans.Rcprx012DspAllPlansParams'
    },
    RCPRX056: {
        programName: 'com.optum.file.prxplanrxnetwork.program.rcprx056dspspntplan.IRcprx056DspSpNtPlanService',
        inputParameterNames: ["carCarrierId", "phnPharmacyNetworkId", "plnNetworkType", "regRegionCode", "snhSuperNetworkDesc", "mediatorId"],
        inputParameterClass: 'com.optum.file.prxplanrxnetwork.program.rcprx056dspspntplan.Rcprx056DspSpNtPlanParams'
    },
    RCPRX057: {
        programName: 'com.optum.file.prxplanrxnetwork.program.rcprx057dspspntplnall.IRcprx057DspSpNtPlnallService',
        inputParameterNames: ["carCarrierId", "phnPharmacyNetworkId", "planCode", "plnNetworkType", "regRegionCode", "snhSuperNetworkDesc", "mediatorId"],
        inputParameterClass: 'com.optum.file.prxplanrxnetwork.program.rcprx057dspspntplnall.Rcprx057DspSpNtPlnallParams'
    },
    RCGNL008 : {
        programName: 'com.optum.file.gnlphngpisuperlist.program.rcgnl008sltaddphgpislst.IRcgnl008SltAddphgpislstService',
        inputParameterNames: [
            "carCarrierId",
            "phnNetworkType",
            "phnPharmacyNetworkId",
            "phnPharmacyNetworkName",
            "phnSeqNbr",
            "planCode",
            "planEffDate",
            "plnNetworkType",
            "regRegionCode",
            "sndCarrierId",
            "sndRegionCode",
            "snhNetworkType",
            "snhSeqNbr",
            "snhSuperNetworkId",
            "wrkCallInPlanLevel",
            "wrkPharmNtLevel",
            "gnlPhnGpiSuperListdsc",
            "gnlPhnGpiSuperListid"],
        inputParameterClass: 'com.optum.file.gnlphngpisuperlist.program.rcgnl008sltaddphgpislst.Rcgnl008SltAddphgpislstParams'
    },
    RCSND002 : {
        programName: 'com.optum.file.sndsupernetworkdetail.program.rcsnd002dsppharnetact.IRcsnd002DspPharNetActService',
        inputParameterNames: [
            "carCarrierId",
            "regRegionCode",
            "snhNetworkType",
            "snhSeqNbr",
            "snhSuperNetworkId",
            "snhSuperNetworkDesc"],
        inputParameterClass: 'com.optum.file.sndsupernetworkdetail.program.rcsnd002dsppharnetact.Rcsnd002DspPharNetActParams'
    },
    RCPHD002: {
        programName: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd002dsppharnetact.IRcphd002DspPharNetActService',
        inputParameterNames: ["carCarrierId", "phnNetworkType", "phnPharmacyNetworkId", "phnPharmacyNetworkName", "phnSeqNbr", "regRegionCode"],
        inputParameterClass: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd002dsppharnetact.Rcphd002DspPharNetActParams'
    },
    RCPHD004: {
        programName: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd004addpharnetwnd.IRcphd004AddPharNetWndService',
        inputParameterNames: ["phaPharmacyId", "mediatorId"],
        inputParameterClass: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd004addpharnetwnd.Rcphd004AddPharNetWndParams'
    },
    RCMSG002:{
        programName: 'com.optum.file.msgmessage.program.rcmsg002selectmessage.IRcmsg002SelectMessageService',
        inputParameterNames: ["msgMessageCde"],
        inputParameterClass: 'com.optum.file.msgmessage.program.rcmsg002selectmessage.Rcmsg002SelectMessageParams'
    },
    RCMSG005I: {
        programName: 'com.optum.file.msgmessage.program.rcmsg005idspmessage.IRcmsg005iDspMessageService',
        inputParameterNames: ["msgMessageCde", "msgSeqNbr", "programMode2"],
        inputParameterClass: 'com.optum.file.msgmessage.program.rcmsg005idspmessage.Rcmsg005iDspMessageParams'
    },
    RCPHA991: {
        programName: 'com.optum.file.phapharmacy.program.rcpha991selectbyid.IRcpha991SelectByIdService',
        inputParameterNames: ["phaPharmacyId"],
        inputParameterClass: 'com.optum.file.phapharmacy.program.rcpha991selectbyid.Rcpha991SelectByIdParams'
    },
    RCSNH004: {
        programName: 'com.optum.file.snhsupernetworkheader.program.rcsnh004editnetwork.IRcsnh004EditNetworkService',
        inputParameterNames: ["carCarrierId", "regRegionCode", "snhSeqNbr","snhSuperNetworkDesc",
            "snhSuperNetworkId","workInitialProgramMode","programMode3"],
        inputParameterClass: 'com.optum.file.snhsupernetworkheader.program.rcsnh004editnetwork.Rcsnh004EditNetworkParams'
    },
    RCRX2005:{
    programName: 'com.optum.file.rx2pharntwkgpilist.program.rcrx2005selgpilist.IRcrx2005SelGpiListService',
    inputParameterNames: ["rx2PharGpiListName"],
    inputParameterClass: 'com.optum.file.rx2pharntwkgpilist.program.rcrx2005selgpilist.Rcrx2005SelGpiListParams'
    },
    RCRX1005:{
        programName: 'com.optum.file.rx1pharntwkndclist.program.rcrx1005selndclist.IRcrx1005SelNdcListService',
        inputParameterNames: ["rx1PharNdcListName"],
        inputParameterClass: 'com.optum.file.rx1pharntwkndclist.program.rcrx1005selndclist.Rcrx1005SelNdcListParams'
    },
    RCPCT991:{
        programName: 'com.optum.file.pctcontract.program.rcpct991selcarrcontdf.IRcpct991SelCarrContDfService',
        inputParameterNames: ["carCarrierId","pctContractId"],
        inputParameterClass: 'com.optum.file.pctcontract.program.rcpct991selcarrcontdf.Rcpct991SelCarrContDfParams'
    },
    RCPHU001:{
        programName: 'com.optum.file.phupharsuppressupdate.program.rcphu001editsupupdate.IRcphu001EditSupUpdateService',
        inputParameterNames: ["carCarrierId","phaPharmacyId","phaPharmacyNameFull","phdSeqNbr","phnPharmacyNetworkId","phnSeqNbr","regRegionCode"],
        inputParameterClass: 'com.optum.file.phupharsuppressupdate.program.rcphu001editsupupdate.Rcphu001EditSupUpdateParams'
    },
    RCRGN001:{
        programName: 'com.optum.file.rgnregionnotes.program.rcrgn001editregionnote.IRcrgn001EditRegionNoteService',
        inputParameterNames: ["regRegionCode","regRegionName"],
        inputParameterClass: 'com.optum.file.rgnregionnotes.program.rcrgn001editregionnote.Rcrgn001EditRegionNoteParams'
    },
    RCPHD002I:{
        programName: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd002idsppharnetact.IRcphd002idspPharNetActService',
        inputParameterNames: ["carCarrierId","phnNetworkType","phnPharmacyNetworkId","phnPharmacyNetworkName","phnSeqNbr","regRegionCode"],
        inputParameterClass: 'com.optum.file.phdpharmacynetworkdtl.program.rcphd002idsppharnetact.Rcphd002idspPharNetActParams'
    },
     RCPHN990:{
        programName: 'com.optum.file.phnpharmacynetwork.program.rcphn990selectanetwork.IRcphn990SelectANetworkService',
        inputParameterNames: ["carCarrierId","phnNetworkType","phnPharmacyNetworkId","phnPharmacyNetworkName","phnSeqNbr","regRegionCode"],
        inputParameterClass: 'com.optum.file.phnpharmacynetwork.program.rcphn990selectanetwork.Rcphn990SelectANetworkParams'
     },
    RCPHN004:{
        programName: 'com.optum.file.phnpharmacynetwork.program.rcphn004editnetwork.IRcphn004EditNetworkService',
        inputParameterNames: ["carCarrierId","phnNetworkType","phnPharmacyNetworkId","phnPharmacyNetworkName","phnSeqNbr","regRegionCode","workInitialProgramMode","programMode3"],
        inputParameterClass: 'com.optum.file.phnpharmacynetwork.program.rcphn004editnetwork.Rcphn004EditNetworkParams'
    },
     RCPHA996:{
        programName: 'com.optum.file.phapharmacy.program.rcpha996selectpharmacy.IRcpha996SelectPharmacyService',
        inputParameterNames: ["phaPharmacyId"],
        inputParameterClass: 'com.optum.file.phapharmacy.program.rcpha996selectpharmacy.Rcpha996SelectPharmacyParams'
    },
    RCPID032:{
        programName: 'com.optum.file.pidproductid.program.rcpid032ndcaddbynmact.IRcpid032NdcAddBynmActService',
        inputParameterNames: ["fnlNdcListDescription","mrndlNdcListName","wrkCharacter3"],
        inputParameterClass: 'com.optum.file.pidproductid.program.rcpid032ndcaddbynmact.Rcpid032NdcAddBynmActParams'
    },
    RCDSC005: {
        programName: 'com.optum.file.dscdeductibleschctrl.program.rcdsc005selectdedsched.IRcdsc005SelectDedSchedService',
        inputParameterNames: ["dscScheduleName", "mediatorId"],
        inputParameterClass: 'com.optum.file.dscdeductibleschctrl.program.rcdsc005selectdedsched.Rcdsc005SelectDedSchedParams'
    },
    RCOPC005: {
        programName: 'com.optum.file.opcoutpoktmaxschctrl.program.rcopc005sltoutpktmxsch.IRcopc005SltOutpktmxSchService',
        inputParameterNames: ["opcScheduleName", "mediatorId"],
        inputParameterClass: 'com.optum.file.opcoutpoktmaxschctrl.program.rcopc005sltoutpktmxsch.Rcopc005SltOutpktmxSchParams'
    },
    RCBSC005: {
        programName: 'com.optum.file.bscbenefitschctrl.program.rcbsc005selectbensch.IRcbsc005SelectBenSchService',
        inputParameterNames: ["bscScheduleName", "mediatorId"],
        inputParameterClass: 'com.optum.file.bscbenefitschctrl.program.rcbsc005selectbensch.Rcbsc005SelectBenSchParams'
    },
};

export function getProgramParameters(programName: string): programInformation | undefined {
    return programs[programName];
}


export function getProgramUrl(programName: string, parameters?: string[]): string | undefined {
    // get program informations
    let url = undefined;
    // return program url
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        url = `/program/${programName}${urlParameters}`
    
    console.log("Navigating to " + url);
    return url;
}

